import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatInputModule } from "@angular/material/input";
import {MatTimepicker, MatTimepickerModule, MatTimepickerSelected} from '@angular/material/timepicker';
import { MatDatepickerInputEvent, MatDatepickerModule, MatStartDate } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DbService } from '../service/db-service.service';

@Component({
  selector: 'app-adjust-date-time-dialog',
  imports: [MatDialogModule, MatInputModule, MatTimepicker, MatTimepickerModule,
    MatDatepickerModule, MatNativeDateModule, FormsModule, ReactiveFormsModule],
  templateUrl: './adjust-date-time-dialog.component.html',
  styleUrl: './adjust-date-time-dialog.component.sass'
})
export class AdjustDateTimeDialogComponent implements OnInit {
  currentDate: Date = new Date();
  min = null;
  max = null;
  message: string;
  public disabled = false;
  public showSpinners = true;
  public showSeconds = false;
  public touchUi = false;
  public enableMeridian = false;
  public stepHour = 1;
  public stepMinute = 1;
  public stepSecond = 1;
  @ViewChild('picker') mypicker: any;
  @ViewChild('timepicker') timepicker!: MatTimepicker<Date>;
  eventStartDate: Date = new Date();
  eventEndDate: Date = new Date();
  eventStartTime: Date = new Date();
  eventDateChanged = false;
  showDateandTimeCtrl = false;
  eventtitle: string = '';
  range;
  readonly minDate = new Date(); // Sets the minimum date to today
  constructor(private fb:FormBuilder,private dbService: DbService, 
    public dialogRef: MatDialogRef<AdjustDateTimeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { eventtitle: string }
  ) {
    this.eventtitle = data.eventtitle;
  }
 
  ngOnInit(): void {
    this.range = new FormGroup({
        datestartvalue: new FormControl<Date | null>(null, [Validators.required]),
        dateendvalue: new FormControl<Date | null>(null, [Validators.required]),
        timevalue: new FormControl<Date | null>(this.currentDate, [Validators.required]),
        date: new FormControl(null, [Validators.required]),
        date2: new FormControl(null, [Validators.required]),
          start: new FormControl<Date | null>(null),
          end: new FormControl<Date | null>(null)
    });
  }

  onConfirm(): void {
    this.dialogRef.close({eventStartDate: this.eventStartDate, eventEndDate: this.eventEndDate, eventStartTime: this.eventStartTime, eventDateChanged: this.eventDateChanged}); 
  }

  onCancel(): void {
    this.dialogRef.close(false); // Close with a 'false' result
  }

   onStartDateChange(event: MatDatepickerInputEvent<Date>): void {
    console.log('Start date changed:', event.value);
    this.eventStartDate = event.value;
    this.eventDateChanged = true;
  }

  onEndDateChange(event: MatDatepickerInputEvent<Date>): void {
    console.log('End date changed:', event.value);
    this.eventEndDate = event.value;
    this.eventDateChanged = true;
  }

  onTimeSelected(time: Date | null) {
    if (time) {
      console.log('Time updated:', time);
      this.eventStartTime = time; // Update the event start time
      this.eventDateChanged = true;
      // Perform actions with the updated time here
    } else {
      this.message ='Time cleared or invalid';
    }
  }
}
